export default __webpack_public_path__ + "static/media/balloon_mobail1.9cc516d8.png";